import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar/Sidebar";
import { Box, Stack, useTheme } from 'convertupleads-theme';

const Dashboard = ({ children }) => {
  const theme = useTheme();
  return (
    <Box sx={{ height: "100vh" }}>
      <Header />
      <Stack direction={"row"} sx={{ height: "calc(100% - 67px)" }}>
        <Sidebar />
        <Stack
          spacing={2}
          sx={{
            flex: 1,
            height: "100%",
            backgroundColor: theme.palette.other.outlinedBorder,
            padding: "16px",
            overflowY: "auto",
          }}
        >
          {children}
        </Stack>
      </Stack>
    </Box>
  );
};

export default Dashboard;
